import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { ReactElement } from 'react'
import { MobileImpressumScreen } from './MobileImpressumScreen'
import { WebImpressumScreen } from './WebImpressumScreen'

export const ImpressumScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)

  return isMobile ? <MobileImpressumScreen /> : <WebImpressumScreen />
}
